import { tagName as adminUserContainer } from '@treasury/domain-components/company-user/company-user.component';
import { companyUserListTagName as adminUserListContainer } from '@treasury/domain-components/company-users/company-users.types';
import { tagName as forgotPasswordTagName } from '@treasury/domain-components/login/components/forgot-password';
import { tagName as ssoCallbackContainerTagName } from '@treasury/domain-components/login/sso-callback-container';
import { tagName as uisContainerTagName } from '@treasury/domain-components/login/uis-container';
import { Commands, RouteContext } from '@vaadin/router';
import { tagName as accountsResearchTransactionsContainer } from '../accounts/containers/accounts-research-transactions-container';
import { tagName as achPaymentsContainerTagName } from '../ach/containers/ach-payments-container';
import { tagName as accountNicknamesContainer } from '../admin/containers/account-nicknames-container';
import { tagName as JhdDashboardTagName } from '../dashboard/containers/dashboard';
import { tagName as depositActivityContainerTagName } from '../deposits/containers/deposit-activity-container';
import { tagName as depositContainerTagName } from '../deposits/containers/deposit-container';
import { tagName as loanWorkflowContainer } from '../loans/containers/loan-workflow-container';
import { tagName as loansContainer } from '../loans/containers/loans-container';
import { tagName as composeMessageContainerTagName } from '../message-center/containers/compose-message-container';
import { tagName as messageCenterContainerTagName } from '../message-center/containers/message-center-container';
import { tagName as achExceptionsContainerTagName } from '../positive-pay/ach-exceptions/containers/ach-exceptions-container';
import { tagName as achFiltersTagName } from '../positive-pay/ach-exceptions/containers/ach-filters-container';
import { tagName as checkExceptionDetailContainerTagName } from '../positive-pay/check-exceptions/containers/check-exception-detail-container';
import { tagName as checkExceptionsContainerTagName } from '../positive-pay/check-exceptions/containers/check-exceptions-container';
import { tagName as reportContainerTagName } from '../reports/containers/report-container';
import { tagName as StopPaymentActivityContainerTagName } from '../stop-payments/containers/stop-payment-activity-container';
import { tagName as StopPaymentWorkflowContainer } from '../stop-payments/containers/stop-payment-workflow-container';
import { tagName as wireContainer } from '../wires/containers/wire-container';
import { tagName as wireFilesContainer } from '../wires/containers/wire-files-container';
import { tagName as WireUploadFormatContainer } from '../wires/containers/wire-upload-format-container';
import { tagName as wiresContainer } from '../wires/containers/wires-container';
import { tagName as wiresWorkflowContainer } from '../wires/containers/wires-workflow-container';
import { tagName as wiresCreditorContainer } from '../wires/creditors/containers/creditor-container';
import { tagName as wiresCreditorWorkflowContainer } from '../wires/creditors/containers/creditor-workflow-container';
import { tagName as wiresCreditorsContainer } from '../wires/creditors/containers/creditors-container';
import { tagName as wiresTemplateContainer } from '../wires/templates/containers/wire-template-container';
import { tagName as wiresTemplateWorkflowContainer } from '../wires/templates/containers/wire-template-workflow-container';
import { tagName as wiresTemplatesContainer } from '../wires/templates/containers/wire-templates-container';
import { pageEnabled } from './authGuard';

export const routes = [
    { path: '/:institution/login', component: uisContainerTagName },
    { path: '/:institution/login/sso', component: ssoCallbackContainerTagName },
    { path: '/:institution/login/bff', component: ssoCallbackContainerTagName },

    { path: '/:institution/forgot-password', component: forgotPasswordTagName },
    {
        path: '/:institution/terms-and-conditions-accept',
        component: 'terms-and-conditions',
    },
    {
        path: '/:institution',
        component: 'jhd-layout',
        action: (context: RouteContext, commands: Commands) =>
            pageEnabled(context, commands, '/:institution/login'),
        children: [
            { path: '/dashboard', component: JhdDashboardTagName },
            {
                path: '/accounts',
                component: 'accounts-container',
            },
            {
                path: '/accounts/research-transactions',
                component: accountsResearchTransactionsContainer,
            },
            { path: '/accounts/:type/:id', component: 'account-container' },
            {
                path: '/accounts/:type/:accountId/transaction/:id',
                component: 'transaction-container',
            },
            { path: '/pending-approvals/:id', component: 'pending-approvals-container' },
            { path: '/ach', component: achPaymentsContainerTagName },
            { path: '/ach/templates/:action?', component: 'ach-templates-container' },
            { path: '/ach/templates/:view/:id', component: 'ach-template-container' },
            { path: '/ach/:id', component: 'ach-payment-container' },
            { path: '/ach/:type/:action/:id?', component: 'ach-workflow-container' },
            { path: '/admin/users/user-list', component: adminUserListContainer },
            { path: '/admin/users/new-user', component: adminUserContainer },
            { path: '/admin/users/:userId', component: adminUserContainer },
            { path: '/admin/account-nicknames', component: accountNicknamesContainer },
            { path: '/business-bill-pay', component: 'business-bill-pay-container' },
            { path: '/business-bill-pay/payees', component: 'business-bill-pay-payees-container' },
            {
                path: '/business-bill-pay/payment/:type/:id',
                component: 'business-bill-pay-payment-detail-container',
            },
            {
                path: '/business-bill-pay/payees/:id',
                component: 'business-bill-pay-payee-detail-container',
            },
            {
                path: '/business-bill-pay/payments/:workflow/:id',
                component: 'business-bill-pay-workflow-container',
            },
            { path: '/loans', component: loansContainer },
            { path: '/loans/:id', component: 'loan-container' },
            {
                path: '/loans/:type/:action/:id',
                component: loanWorkflowContainer,
            },
            { path: '/transfers', component: 'transfers-container' },
            {
                path: '/transfers/templates/:action?',
                component: 'transfer-templates-container',
            },
            {
                path: '/transfers/template/:view/:id',
                component: 'transfer-template-container',
            },
            { path: '/transfers/:id', component: 'transfer-container' },
            {
                path: '/transfers/:workflow/:action/:id/:type?',
                component: 'transfer-workflow-container',
            },
            { path: '/wires', component: wiresContainer },
            { path: '/wires/files', component: wireFilesContainer },
            { path: '/wires/files/:id', component: WireUploadFormatContainer },
            { path: '/wires/creditors', component: wiresCreditorsContainer },
            { path: '/wires/creditors/view/:id', component: wiresCreditorContainer },
            { path: '/wires/creditors/:action/:id?', component: wiresCreditorWorkflowContainer },
            { path: '/wires/:id', component: wireContainer },
            { path: '/wires/template/:id', component: wiresTemplateContainer },
            {
                path: '/wires/template/:action/:id/:currency?',
                component: wiresTemplateWorkflowContainer,
            },
            {
                path: '/wires/:type/:action/:id/:currency?',
                component: wiresWorkflowContainer,
            },
            {
                path: '/wires/templates/:action?',
                component: wiresTemplatesContainer,
            },
            {
                path: '/positive-pay/check-exceptions',
                component: checkExceptionsContainerTagName,
            },
            {
                path: '/positive-pay/check-exceptions/:id',
                component: checkExceptionDetailContainerTagName,
            },
            {
                path: '/positive-pay/ach-exceptions',
                component: achExceptionsContainerTagName,
            },
            {
                path: '/positive-pay/ach-filters',
                component: achFiltersTagName,
            },
            {
                path: '/stop-payments',
                component: StopPaymentActivityContainerTagName,
            },
            {
                path: '/stop-payments/:type/:workflow',
                component: StopPaymentWorkflowContainer,
            },
            { path: '/deposit', component: depositActivityContainerTagName },
            { path: '/create-deposit', component: depositContainerTagName },
            { path: '/edit-deposit/:id', component: depositContainerTagName },
            { path: '/message-center', component: messageCenterContainerTagName },
            { path: '/message-center/compose', component: composeMessageContainerTagName },
            { path: '/message-center/:id', component: 'message-center-detail-container' },
            { path: '/notifications', component: 'notifications-container' },
            { path: '/about', component: 'about-container' },
            { path: '/log-out', component: 'logout-container' },
            { path: '/profile', component: 'user-profile-container' },
            { path: '/users/:id', component: 'user-container' },
            {
                path: '/reports',
                component: reportContainerTagName,
                children: [{ path: '/:type/:id', component: 'report-layout' }],
            },
        ],
    },
    { path: '(.*)', component: 'not-found' },
];
